import { AbstractControl } from '@angular/forms';
import { ErrorReference } from '../enums';
import { AppError } from '../models';
import { DateUtil } from '../utils';

// @dynamic
export class DateValidator {
    static valid(control: AbstractControl) {
        return DateUtil.isInvalid(control.value)
            ? {
                  datumUngueltig: new AppError(ErrorReference.datumUngueltig, [
                      { token: '#DATE_TODAY', str: DateUtil.today() },
                  ]),
              }
            : null;
    }

    static validTime(control: AbstractControl) {
        return !DateUtil.timeIsValid(control.value)
            ? { uhrzeitUngueltig: new AppError(ErrorReference.timeFormat) }
            : null;
    }

    static validJahrMonat(control: AbstractControl) {
        return DateUtil.isInvalid(control.value, 'MM.YYYY')
            ? {
                  datumUngueltig: new AppError(ErrorReference.datumUngueltigJahrMonat, [
                      {
                          token: '#DATE_TODAY',
                          str: DateUtil.today('MM.YYYY'),
                      },
                  ]),
              }
            : null;
    }

    static isInFuture(control: AbstractControl) {
        return DateUtil.isValid(control.value) && DateUtil.isInPast(control.value)
            ? { datumVergangenheit: new AppError(ErrorReference.datumVergangenheit) }
            : null;
    }

    static geburtsdatum(control: AbstractControl) {
        return DateUtil.isValid(control.value) && DateUtil.isInFuture(control.value)
            ? { geburtsdatumInZukunft: new AppError(ErrorReference.geburtsdatumInZukunft) }
            : null;
    }

    static isInFutureWithTime = (dateValueSupplier: () => string) => (control: AbstractControl) => {
        const dateValue = dateValueSupplier();
        if (dateValue && DateUtil.timeIsValid(control.value) && DateUtil.isValid(dateValue)) {
            return DateUtil.isInPastWithTime(`${dateValue} ${control.value}`, 'dd.MM.yyyy HH:mm')
                ? { uhrzeitVergangenheit: new AppError(ErrorReference.uhrzeitVergangenheit) }
                : null;
        }
        return null;
    };
}
